// import React, { useState, useEffect } from "react";
// import { Button, TextField, Grid, Typography, Paper } from "@mui/material";
// import IPDCToastMessageResult from "../../../../../components/Controls/IPDCToastMessageResult";
// import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
// import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
// import * as turf from "@turf/turf";
// import proj4 from "proj4";
// import { IPDCAttachFile1 } from "../../../../../components/Controls";
// import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";
// // Replace this:

// //import { FloatingRightSingleFormNearTop } from "../../../../../styles/Form/FormStyles";

// const SplitForm = React.forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [coordinates, setCoordinates] = useState([{ x: "", y: "" }]);
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");

//   // Auto selection of UPIN when a feature is selected on the map
//   useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const selectedUpin = selectedFeatureOnMap[0]?.get("upin") || "";
//       if (selectedUpin !== upin) {
//         setUpin(selectedUpin);
//       }
//     }
//   }, [selectedFeatureOnMap, upin]);
  
//   const convertToEPSG3857 = (x, y) => {
//     const wgs84 = "+proj=longlat +datum=WGS84 +no_defs"; // EPSG:4326
//     const epsg3857 =
//       "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs"; // EPSG:3857
//     return proj4(wgs84, epsg3857, [x, y]);
//   };
//   const convertToWGS84 = (x, y) => {
//     const epsg3857 =
//       "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs"; // EPSG:3857
//     const wgs84 = "+proj=longlat +datum=WGS84 +no_defs"; // EPSG:4326
//     return proj4(epsg3857, wgs84, [x, y]);
//   };
//   const isCoordinateToSplitFeatureValid = async () => {
//     try {
//       const existingParcels = await MapDataLoader.loadParcels();
//       const featureToSplit = existingParcels.features.find(f => f.properties.upin === upin);

//       if (!featureToSplit) {
//         setResponseMessage("No spatial data found for the given UPIN");
//         setAlertSeverity("error");
//         return false;
//       }

//       const coordinatesOfPoly = featureToSplit.geometry.coordinates;
//       const convertedCoordinates = coordinatesOfPoly[0]?.map(coordinate => {
//         // No conversion needed if coordinates are already in Web Mercator or similar
//         //      console.log("before conversion: ", coordinate);
//         return convertToEPSG3857(coordinate[0], coordinate[1]);
//       });
//       //      console.log("after conversion");
//       const polygon = turf.polygon([convertedCoordinates]);

//       //console.log("Converted coordinates:", polygon);

//       // Convert line coordinates to the same coordinate system as the polygon
//       const points = coordinates.map(coord => {
//         return [parseFloat(coord.x), parseFloat(coord.y)];
//       });
//       if (points.length < 2) {
//         setResponseMessage("At least two points are needed to form a line for splitting.");
//         setAlertSeverity("error");
//         return false;
//       }
//       //console.log("Points for line:", points);
//       const line = turf.lineString(points);
      
//       if (points.length < 2) {
//         setResponseMessage("At least two points are needed to form a line for splitting.");
//         setAlertSeverity("error");
//         return false;
//       }
//       try {
//         const intersection = turf.lineIntersect(polygon, line);
//         //        console.log("Intersection points:", intersection.features.length);
//         if (!intersection?.features?.length) {
//           console.log("no intersection");
//           setResponseMessage("The line does not intersect the polygon.");
//           setAlertSeverity("error");
//           return false;
//         }
//       } catch (err) {
//         console.log("Error in intersection", err);
//       }

//       const bufferedLine = turf.buffer(line, 0.0005, { units: "kilometers" });
//       const splitResult = turf.difference(polygon, bufferedLine);
//       //      console.log("I do not care about the split resul, just checking", splitResult);

//       if (splitResult?.geometry?.type === "MultiPolygon" || splitResult?.geometry?.type === "Polygon") {
//         //        console.log("valid entered to send data, split result(No need for the result only validation) : ", splitResult);
//         return true;
//       } else {
//         console.log("mulualem")
//         setResponseMessage("The line does not split the polygon into multiple parts.");
//         setAlertSeverity("error");
//         return false;
//       }
//     } catch (error) {
//       console.error("Error validating coordinates:", error);
//       setResponseMessage("An error occurred while validating coordinates.");
//       setAlertSeverity("error");
//       return false;
//     }
//   };


//   const addCoordinate = () => {
//     setCoordinates([...coordinates, { x: "", y: "" }]);
//   };

//   const removeCoordinate = index => {
//     setCoordinates(coordinates.filter((_, i) => i !== index));
//   };

//   const handleCoordinateChange = (index, field, value) => {
//     const newCoords = [...coordinates];
//     newCoords[index][field] = value;
//     setCoordinates(newCoords);
//   };

// // const handleSubmit = async e => {
// //   e.preventDefault();
// //   if (coordinates && coordinates.length < 1) {
// //     setResponseMessage("At least two points are needed to form a line for splitting.");
// //     setAlertSeverity("warning");
// //     return;
// //   }
  
// //   // Validate that all coordinates have values
// //   const hasEmptyCoordinates = coordinates.some(coord => !coord.x || !coord.y);
// //   if (hasEmptyCoordinates) {
// //     setResponseMessage("Please fill in all coordinate values.");
// //     setAlertSeverity("warning");
// //     return;
// //   }

// //   const isItPossibleToSplit = await isCoordinateToSplitFeatureValid();
// //   console.log("the result before submit", isItPossibleToSplit);
// //   if (!isItPossibleToSplit) {
// //     setAlertSeverity("warning");
// //     setResponseMessage("The line does not split the polygon into multiple parts.");
// //     return;
// //   } else {
// //     console.log("isItPossibleToSplit :", isItPossibleToSplit ? "true" : "false");
// //     const formDataToSubmit = new FormData();
// //     formDataToSubmit.append("upin", upin);
    
// //     // Filter out any empty coordinates just in case
// //     const validCoordinates = coordinates.filter(coord => coord.x && coord.y);
    
// //     const convertedToWgsForDB = validCoordinates.map(coord => {
// //       return convertToWGS84(parseFloat(coord.x), parseFloat(coord.y));
// //     });

// //     let coordJson = convertedToWgsForDB.map(coord => ({
// //       x: coord[0],  // Changed from coord.x to coord[0] since convertToWGS84 returns an array
// //       y: coord[1]   // Changed from coord.y to coord[1]
// //     }));

// //     // Convert the array to JSON string
// //     let jsonString = JSON.stringify(coordJson);
// //     // Append the JSON string to formData
// //     formDataToSubmit.append("coordinates", jsonString);

// //     formDataToSubmit.append("description", description);
// //     formDataToSubmit.append("file", attachment);
 
// //     const responseData = await ExecutePostWithParams("splitParcel", formDataToSubmit, true);

// //     if (responseData) {
// //       setResponseMessage("Subdivision has been successful. Please refresh the map to see changes.");
// //       setAlertSeverity("success");
      
// //       resetForm();
// //     } else {
// //       setResponseMessage("Subdivision failed");
// //       setAlertSeverity("error");
// //     }
// //   }
// // };
// ////////////////////////
// const handleSubmit = async e => {
//   e.preventDefault();
//   if (coordinates && coordinates.length < 1) {
//     setResponseMessage("At least two points are needed to form a line for splitting.");
//     setAlertSeverity("warning");
//     return;
//   }
  
//   // Validate that all coordinates have values
//   const hasEmptyCoordinates = coordinates.some(coord => !coord.x || !coord.y);
//   if (hasEmptyCoordinates) {
//     setResponseMessage("Please fill in all coordinate values.");
//     setAlertSeverity("warning");
//     return;
//   }

//   // Show success message for coordinate submission
//   setResponseMessage("Split parcel request submitted successfully");
//   setAlertSeverity("success");

//   const isItPossibleToSplit = await isCoordinateToSplitFeatureValid();
//   console.log("the result before submit", isItPossibleToSplit);
//   if (!isItPossibleToSplit) {
//     setAlertSeverity("warning");
//     setResponseMessage("The line does not split the polygon into multiple parts.");
//     return;
//   } else {
//     console.log("isItPossibleToSplit :", isItPossibleToSplit ? "true" : "false");
//     const formDataToSubmit = new FormData();

//     //#########################################
//      try {
//           const formData = new FormData();
//           formData.append("upin", upin);
//           formData.append("description", description);
//           if (attachment) {
//             formData.append("file", attachment);
//           }
          
//           const responseData = await ExecutePostWithParams("mergeParcel", formData, true);
    
//           if (responseData) {
//             setResponseMessage("Merging request submitted successfully!", "success");
//             resetForm();
//           } else {
//             setResponseMessage("Merging failed!", "error");
//           }
//         } catch (err) {
//           console.error(err);
//           setResponseMessage(`Merge failed: ${err.message}`, "error");
//         }
//     //#########################################




//    // formDataToSubmit.append("upin", upin);
    
//     // Filter out any empty coordinates just in case
//     const validCoordinates = coordinates.filter(coord => coord.x && coord.y);
    
//     const convertedToWgsForDB = validCoordinates.map(coord => {
//       return convertToWGS84(parseFloat(coord.x), parseFloat(coord.y));
//     });

//     let coordJson = convertedToWgsForDB.map(coord => ({
//       x: coord[0],  // Changed from coord.x to coord[0] since convertToWGS84 returns an array
//       y: coord[1]   // Changed from coord.y to coord[1]
//     }));

//     // Convert the array to JSON string
//     let jsonString = JSON.stringify(coordJson);
//     // Append the JSON string to formData
//     formDataToSubmit.append("coordinates", jsonString);

//     formDataToSubmit.append("description", description);
//     formDataToSubmit.append("file", attachment);

 
//     const responseData = await ExecutePostWithParams("splitParcel", formDataToSubmit, true);

//     if (responseData) {
//       setResponseMessage("Subdivision has been successful. Please refresh the map to see changes.");
//       setAlertSeverity("success");
      
//       resetForm();
//     } else {
//       setResponseMessage("Subdivision failed");
//       setAlertSeverity("error");
//     }
//   }
// };
// ////////////////////////  
// const resetForm = () => {
//     setUpin("");
//     setCoordinates([{ x: "", y: "" }]);
//     setAttachment(null);
//     setResponseMessage("");
//     setDescription("");
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Typography variant="h5" align="center" gutterBottom>
//           Split Parcel
//         </Typography>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="UPIN"
//               variant="outlined"
//               value={upin}
//               onChange={e => setUpin(e.target.value)}
//               placeholder="Enter UPIN E.g. BL1-001-01"
//               required
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography variant="subtitle1">Coordinates</Typography>
//           </Grid>
//           {coordinates &&
//             coordinates.length > 0 &&
//             coordinates.map((coord, index) => (
//               <React.Fragment key={index}>
//                 {["x", "y"].map(field => (
//                   <Grid item xs={6} key={field}>
//                     <TextField
//                       fullWidth
//                       label={`${field.toUpperCase()}${index + 1}`}
//                       value={coord[field]}
//                       onChange={e => handleCoordinateChange(index, field, e.target.value)}
//                       required
//                     />
//                   </Grid>
//                 ))}
//                 {index > 0 && (
//                   <Grid item xs={12}>
//                     <Button onClick={() => removeCoordinate(index)}>Remove</Button>
//                   </Grid>
//                 )}
//               </React.Fragment>
//             ))}
//           <Grid item xs={12}>
//             <Button onClick={addCoordinate} fullWidth variant="outlined">
//               Add Another Point
//             </Button>
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               id="description"
//               value={description}
//               onChange={e => setDescription(e.target.value)}
//               label="Description"
//               multiline
//               rows={2}
//               fullWidth
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFile1
//               onChange={e => setAttachment(e[0])}
//               label="Attach Order Dcoument"
//               variant="outlined"
//               multiLine={true}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button type="submit" variant="contained" color="primary" fullWidth>
//               Split
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//       {responseMessage && <IPDCToastMessageResult message={responseMessage} type={alertSeverity} />}
//     </Paper>
//   );
// });

// export default SplitForm;


// // import React, { useState, useEffect } from "react";
// // import { Button, TextField, Grid, Typography, Paper } from "@mui/material";
// // import IPDCToastMessageResult from "../../../../../components/Controls/IPDCToastMessageResult";
// // import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
// // import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
// // import * as turf from "@turf/turf";
// // import proj4 from "proj4";
// // import { IPDCAttachFile1 } from "../../../../../components/Controls";
// // import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";

// // // Throttle function to limit alert frequency
// // const throttle = (func, limit) => {
// //   let lastFunc;
// //   let lastRan;

// //   return function() {
// //     const context = this;
// //     const args = arguments;
// //     if (!lastRan) {
// //       func.apply(context, args);
// //       lastRan = Date.now();
// //     } else {
// //       clearTimeout(lastFunc);
// //       lastFunc = setTimeout(function() {
// //         if ((Date.now() - lastRan) >= limit) {
// //           func.apply(context, args);
// //           lastRan = Date.now();
// //         }
// //       }, limit - (Date.now() - lastRan));
// //     }
// //   };
// // };

// // const SplitForm = React.forwardRef(({ selectedFeatureOnMap, mapInstance }, ref) => {
// //   const [upin, setUpin] = useState("");
// //   const [x1, setX1] = useState(""); // State for X1
// //   const [y1, setY1] = useState(""); // State for Y1
// //   const [additionalCoordinates, setAdditionalCoordinates] = useState([{ x: "", y: "" }]);
// //   const [description, setDescription] = useState("");
// //   const [attachment, setAttachment] = useState(null);
// //   const [responseMessage, setResponseMessage] = useState("");
// //   const [alertSeverity, setAlertSeverity] = useState("info");

// //   // Auto selection of UPIN when a feature is selected on the map
// //   useEffect(() => {
// //     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
// //       const selectedUpin = selectedFeatureOnMap[0]?.get("upin") || "";
// //       if (selectedUpin !== upin) {
// //         setUpin(selectedUpin);
// //       }
// //     }
// //   }, [selectedFeatureOnMap, upin]);

// //   // Capture mouse movement over the map
// //   useEffect(() => {
// //     if (!mapInstance) return;

// //     const handleMouseMove = throttle((event) => {
// //       const { lat, lng } = event.latlng; // Adjust based on your mapping library
// //       setX1(lng.toFixed(6)); // Update X1
// //       setY1(lat.toFixed(6)); // Update Y1
// //       alert(`Coordinates: X1 = ${lng.toFixed(6)}, Y1 = ${lat.toFixed(6)}`); // Show alert
// //     }, 1000); // Show alert every second

// //     // Add mousemove event listener for hovering
// //     mapInstance.on('mousemove', handleMouseMove);

// //     return () => {
// //       mapInstance.off('mousemove', handleMouseMove); // Clean up the event listener
// //     };
// //   }, [mapInstance]);

// //   const convertToEPSG3857 = (x, y) => {
// //     const wgs84 = "+proj=longlat +datum=WGS84 +no_defs";
// //     const epsg3857 = "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs";
// //     return proj4(wgs84, epsg3857, [x, y]);
// //   };

// //   const convertToWGS84 = (x, y) => {
// //     const epsg3857 = "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs";
// //     const wgs84 = "+proj=longlat +datum=WGS84 +no_defs";
// //     return proj4(epsg3857, wgs84, [x, y]);
// //   };

// //   const isCoordinateToSplitFeatureValid = async () => {
// //     try {
// //       const existingParcels = await MapDataLoader.loadParcels();
// //       const featureToSplit = existingParcels.features.find(f => f.properties.upin === upin);

// //       if (!featureToSplit) {
// //         setResponseMessage("No spatial data found for the given UPIN");
// //         setAlertSeverity("error");
// //         return false;
// //       }

// //       const coordinatesOfPoly = featureToSplit.geometry.coordinates;
// //       const convertedCoordinates = coordinatesOfPoly[0].map(coordinate => convertToEPSG3857(coordinate[0], coordinate[1]));
// //       const polygon = turf.polygon([convertedCoordinates]);

// //       const points = [...additionalCoordinates.map(coord => [parseFloat(coord.x), parseFloat(coord.y)]), [parseFloat(x1), parseFloat(y1)]]; // Include X1 and Y1
// //       if (points.length < 2) {
// //         setResponseMessage("At least two points are needed to form a line for splitting.");
// //         setAlertSeverity("error");
// //         return false;
// //       }
// //       const line = turf.lineString(points);
// //       const intersection = turf.lineIntersect(polygon, line);

// //       if (!intersection.features.length) {
// //         setResponseMessage("The line does not intersect the polygon.");
// //         setAlertSeverity("error");
// //         return false;
// //       }

// //       const bufferedLine = turf.buffer(line, 0.0005, { units: "kilometers" });
// //       const splitResult = turf.difference(polygon, bufferedLine);

// //       if (splitResult?.geometry?.type === "MultiPolygon" || splitResult?.geometry?.type === "Polygon") {
// //         return true;
// //       } else {
// //         setResponseMessage("The line does not split the polygon into multiple parts.");
// //         setAlertSeverity("error");
// //         return false;
// //       }
// //     } catch (error) {
// //       console.error("Error validating coordinates:", error);
// //       setResponseMessage("An error occurred while validating coordinates.");
// //       setAlertSeverity("error");
// //       return false;
// //     }
// //   };

// //   const addCoordinate = () => {
// //     setAdditionalCoordinates([...additionalCoordinates, { x: "", y: "" }]);
// //   };

// //   const removeCoordinate = index => {
// //     setAdditionalCoordinates(additionalCoordinates.filter((_, i) => i !== index));
// //   };

// //   const handleAdditionalCoordinateChange = (index, field, value) => {
// //     const newCoords = [...additionalCoordinates];
// //     newCoords[index][field] = value;
// //     setAdditionalCoordinates(newCoords);
// //   };

// //   const handleSubmit = async e => {
// //     e.preventDefault();
// //     if (!x1 || !y1) {
// //       setResponseMessage("Please provide coordinates for X1 and Y1.");
// //       setAlertSeverity("warning");
// //       return;
// //     }

// //     const isItPossibleToSplit = await isCoordinateToSplitFeatureValid();
// //     if (!isItPossibleToSplit) {
// //       setAlertSeverity("warning");
// //       setResponseMessage("The line does not split the polygon into multiple parts.");
// //       return;
// //     }

// //     const formDataToSubmit = new FormData();
// //     formDataToSubmit.append("upin", upin);

// //     const validCoordinates = additionalCoordinates.filter(coord => coord.x && coord.y);
// //     const coordJson = validCoordinates.map(coord => ({
// //       x: coord.x,
// //       y: coord.y
// //     }));

// //     // Include X1 and Y1 in the coordinates
// //     coordJson.push({ x: x1, y: y1 });

// //     formDataToSubmit.append("coordinates", JSON.stringify(coordJson));
// //     formDataToSubmit.append("description", description);
// //     formDataToSubmit.append("file", attachment);

// //     const responseData = await ExecutePostWithParams("splitParcel", formDataToSubmit, true);
// //     if (responseData) {
// //       setResponseMessage("Subdivision has been successful. Please refresh the map to see changes.");
// //       setAlertSeverity("success");
// //       resetForm();
// //     } else {
// //       setResponseMessage("Subdivision failed");
// //       setAlertSeverity("error");
// //     }
// //   };

// //   const resetForm = () => {
// //     setUpin("");
// //     setX1("");
// //     setY1("");
// //     setAdditionalCoordinates([{ x: "", y: "" }]);
// //     setAttachment(null);
// //     setResponseMessage("");
// //     setDescription("");
// //   };

// //   return (
// //     <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
// //       <form onSubmit={handleSubmit} ref={ref}>
// //         <Typography variant="h5" align="center" gutterBottom>
// //           Split Parcel
// //         </Typography>
// //         <Grid container spacing={1}>
// //           <Grid item xs={12}>
// //             <TextField
// //               fullWidth
// //               label="UPIN"
// //               variant="outlined"
// //               value={upin}
// //               onChange={e => setUpin(e.target.value)}
// //               placeholder="Enter UPIN E.g. BL1-001-01"
// //               required
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <Typography variant="subtitle1">Coordinates</Typography>
// //           </Grid>
// //           <Grid item xs={6}>
// //             <TextField
// //               fullWidth
// //               label="X1"
// //               value={x1} // Bind to X1
// //               onChange={e => setX1(e.target.value)}
// //               required
// //               //disabled // Optional: Disable to prevent manual editing
// //             />
// //           </Grid>
// //           <Grid item xs={6}>
// //             <TextField
// //               fullWidth
// //               label="Y1"
// //               value={y1} // Bind to Y1
// //               onChange={e => setY1(e.target.value)}
// //               required
// //               //disabled // Optional: Disable to prevent manual editing
// //             />
// //           </Grid>
// //           {additionalCoordinates.map((coord, index) => (
// //             <React.Fragment key={index}>
// //               {["x", "y"].map(field => (
// //                 <Grid item xs={6} key={field}>
// //                   <TextField
// //                     fullWidth
// //                     label={`${field.toUpperCase()}${index + 2}`} // Adjust label accordingly
// //                     value={coord[field]}
// //                     onChange={e => handleAdditionalCoordinateChange(index, field, e.target.value)}
// //                     required
// //                   />
// //                 </Grid>
// //               ))}
// //               <Grid item xs={12}>
// //                 <Button onClick={() => removeCoordinate(index)}>Remove</Button>
// //               </Grid>
// //             </React.Fragment>
// //           ))}
// //           <Grid item xs={12}>
// //             <Button onClick={addCoordinate} fullWidth variant="outlined">
// //               Add Another Point
// //             </Button>
// //           </Grid>
// //           <Grid item xs={12}>
// //             <TextField
// //               id="description"
// //               value={description}
// //               onChange={e => setDescription(e.target.value)}
// //               label="Description"
// //               multiline
// //               rows={2}
// //               fullWidth
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <IPDCAttachFile1
// //               onChange={e => setAttachment(e[0])}
// //               label="Attach Order Document"
// //               variant="outlined"
// //               multiLine={true}
// //             />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <Button type="submit" variant="contained" color="primary" fullWidth>
// //               Split
// //             </Button>
// //           </Grid>
// //         </Grid>
// //       </form>
// //       {responseMessage && <IPDCToastMessageResult message={responseMessage} type={alertSeverity} />}
// //     </Paper>
// //   );
// // });

///////////////////////////

// export default SplitForm;

import React, { useState, useEffect, useCallback } from "react";
import { Button, TextField, Grid, Typography, Paper } from "@mui/material";
import IPDCToastMessageResult from "../../../../../components/Controls/IPDCToastMessageResult";
import { FloatingRightSingleFormDownFromSearchPark } from "../../../../../styles/Form/FormStyles";
import * as MapDataLoader from "../MapRelated/MapData/MapDataLoader";
import * as turf from "@turf/turf";
import proj4 from "proj4";
import { IPDCAttachFile1 } from "../../../../../components/Controls";
import { ExecutePostWithParams } from "../../../../../services/api/ExecuteApiRequests";

const SplitForm = React.forwardRef(({ selectedFeatureOnMap }, ref) => {
  const [upin, setUpin] = useState("");
  const [coordinates, setCoordinates] = useState([{ x: "", y: "" }]);
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Auto selection of UPIN when a feature is selected on the map
  useEffect(() => {
    if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
      const selectedUpin = selectedFeatureOnMap[0]?.get("upin") || "";
      if (selectedUpin !== upin) {
        setUpin(selectedUpin);
      }
    }
  }, [selectedFeatureOnMap, upin]);
  
  // Clear message after a delay
  const clearMessage = useCallback(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
      setAlertSeverity("info");
    }, 5000);
    
    return () => clearTimeout(timer);
  }, []);

  const showToastMessage = useCallback((message, severity) => {
    setResponseMessage("");
    setTimeout(() => {
      setResponseMessage(message);
      setAlertSeverity(severity);
      clearMessage();
    }, 10);
  }, [clearMessage]);

  // NEW: Check for existing split requests
  const checkExistingSplitRequests = useCallback(async (upin) => {
    try {
      const response = await ExecutePostWithParams(
        "checkExistingSplitRequests", 
        { upin: upin.trim() }, 
        false
      );
      
      if (response && response.hasExistingRequests) {
        return {
          hasExisting: true,
          message: response.message || `Parcel ${upin} already has a pending split request. Please wait for existing request to be processed.`
        };
      }
      
      return { hasExisting: false, message: "" };
    } catch (error) {
      console.error("Error checking existing split requests:", error);
      // If the check fails, we'll proceed with the split request
      return { hasExisting: false, message: "" };
    }
  }, []);

  const convertToEPSG3857 = (x, y) => {
    const wgs84 = "+proj=longlat +datum=WGS84 +no_defs";
    const epsg3857 =
      "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs";
    return proj4(wgs84, epsg3857, [x, y]);
  };

  const convertToWGS84 = (x, y) => {
    const epsg3857 =
      "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs";
    const wgs84 = "+proj=longlat +datum=WGS84 +no_defs";
    return proj4(epsg3857, wgs84, [x, y]);
  };

  const isCoordinateToSplitFeatureValid = async () => {
    try {
      const existingParcels = await MapDataLoader.loadParcels();
      const featureToSplit = existingParcels.features.find(f => f.properties.upin === upin);

      if (!featureToSplit) {
        showToastMessage("No spatial data found for the given UPIN", "error");
        return false;
      }

      const coordinatesOfPoly = featureToSplit.geometry.coordinates;
      const convertedCoordinates = coordinatesOfPoly[0]?.map(coordinate => {
        return convertToEPSG3857(coordinate[0], coordinate[1]);
      });

      const polygon = turf.polygon([convertedCoordinates]);

      // Convert line coordinates to the same coordinate system as the polygon
      const points = coordinates.map(coord => {
        return [parseFloat(coord.x), parseFloat(coord.y)];
      });
      
      if (points.length < 2) {
        showToastMessage("At least two points are needed to form a line for splitting.", "error");
        return false;
      }
      
      const line = turf.lineString(points);
      
      try {
        const intersection = turf.lineIntersect(polygon, line);
        if (!intersection?.features?.length) {
          showToastMessage("The line does not intersect the polygon.", "error");
          return false;
        }
      } catch (err) {
        console.log("Error in intersection", err);
      }

      const bufferedLine = turf.buffer(line, 0.0005, { units: "kilometers" });
      const splitResult = turf.difference(polygon, bufferedLine);

      if (splitResult?.geometry?.type === "MultiPolygon" || splitResult?.geometry?.type === "Polygon") {
        return true;
      } else {
        showToastMessage("The line does not split the polygon into multiple parts.", "error");
        return false;
      }
    } catch (error) {
      console.error("Error validating coordinates:", error);
      showToastMessage("An error occurred while validating coordinates.", "error");
      return false;
    }
  };

  const addCoordinate = () => {
    setCoordinates([...coordinates, { x: "", y: "" }]);
  };

  const removeCoordinate = index => {
    setCoordinates(coordinates.filter((_, i) => i !== index));
  };

  const handleCoordinateChange = (index, field, value) => {
    const newCoords = [...coordinates];
    newCoords[index][field] = value;
    setCoordinates(newCoords);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (isSubmitting) {
      showToastMessage("Please wait, previous request is processing...", "info");
      return;
    }
    
    setIsSubmitting(true);

    try {
      // Validate UPIN is not empty
      if (!upin.trim()) {
        showToastMessage("Please enter a UPIN", "warning");
        return;
      }

      if (coordinates && coordinates.length < 1) {
        showToastMessage("At least two points are needed to form a line for splitting.", "warning");
        return;
      }
      
      // Validate that all coordinates have values
      const hasEmptyCoordinates = coordinates.some(coord => !coord.x || !coord.y);
      if (hasEmptyCoordinates) {
        showToastMessage("Please fill in all coordinate values.", "warning");
        return;
      }

      // NEW: Check for existing split requests before proceeding
      const existingRequestsCheck = await checkExistingSplitRequests(upin);
      if (existingRequestsCheck.hasExisting) {
        showToastMessage(existingRequestsCheck.message, "warning");
        return;
      }

      const isItPossibleToSplit = await isCoordinateToSplitFeatureValid();
      console.log("the result before submit", isItPossibleToSplit);
      
      if (!isItPossibleToSplit) {
        showToastMessage("The line does not split the polygon into multiple parts.", "warning");
        return;
      }

      // Prepare form data for submission
      const formDataToSubmit = new FormData();
      formDataToSubmit.append("upin", upin);
      
      // Filter out any empty coordinates just in case
      const validCoordinates = coordinates.filter(coord => coord.x && coord.y);
      
      const convertedToWgsForDB = validCoordinates.map(coord => {
        return convertToWGS84(parseFloat(coord.x), parseFloat(coord.y));
      });

      let coordJson = convertedToWgsForDB.map(coord => ({
        x: coord[0],
        y: coord[1]
      }));

      // Convert the array to JSON string
      let jsonString = JSON.stringify(coordJson);
      formDataToSubmit.append("coordinates", jsonString);
      formDataToSubmit.append("description", description);
      
      if (attachment) {
        formDataToSubmit.append("file", attachment);
      }

      const responseData = await ExecutePostWithParams("splitParcel", formDataToSubmit, true);

      if (responseData) {
        showToastMessage("Split request submitted successfully! Please wait for approval.", "success");
        resetForm();
      } else {
        showToastMessage("Split request failed!", "error");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      showToastMessage("An error occurred during submission", "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const resetForm = () => {
    setUpin("");
    setCoordinates([{ x: "", y: "" }]);
    setAttachment(null);
    setDescription("");
  };

  return (
    <Paper sx={{ ...FloatingRightSingleFormDownFromSearchPark }} elevation={3}>
      <form onSubmit={handleSubmit} ref={ref}>
        <Typography variant="h5" align="center" gutterBottom>
          Split Parcel
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="UPIN"
              variant="outlined"
              value={upin}
              onChange={e => setUpin(e.target.value)}
              placeholder="Enter UPIN E.g. BL1-001-01"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Coordinates</Typography>
          </Grid>
          {coordinates &&
            coordinates.length > 0 &&
            coordinates.map((coord, index) => (
              <React.Fragment key={index}>
                {["x", "y"].map(field => (
                  <Grid item xs={6} key={field}>
                    <TextField
                      fullWidth
                      label={`${field.toUpperCase()}${index + 1}`}
                      value={coord[field]}
                      onChange={e => handleCoordinateChange(index, field, e.target.value)}
                      required
                    />
                  </Grid>
                ))}
                {index > 0 && (
                  <Grid item xs={12}>
                    <Button onClick={() => removeCoordinate(index)}>Remove</Button>
                  </Grid>
                )}
              </React.Fragment>
            ))}
          <Grid item xs={12}>
            <Button onClick={addCoordinate} fullWidth variant="outlined">
              Add Another Point
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              label="Description"
              multiline
              rows={2}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <IPDCAttachFile1
              onChange={e => setAttachment(e[0])}
              label="Attach Order Document"
              variant="outlined"
              multiLine={true}
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              fullWidth
              disabled={isSubmitting}
            >
              {isSubmitting ? "Splitting..." : "Split"}
            </Button>
          </Grid>
        </Grid>
      </form>
      {responseMessage && (
        <IPDCToastMessageResult 
          message={responseMessage} 
          type={alertSeverity} 
          onClose={() => setResponseMessage("")}
        />
      )}
    </Paper>
  );
});

export default SplitForm;

